import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

import { authRequest, authResponse } from './interceptors';
import { checkPermissionRequest } from './checkPermission';

import CONFIG from '@config';

export const http = axios.create({
  baseURL: CONFIG.API_URL,
});

http.interceptors.request.use(authRequest);
http.interceptors.response.use(...authResponse);
http.interceptors.request.use(checkPermissionRequest);

const cache = setupCache({
  maxAge: 5 * 60 * 1000,
  exclude: { query: false },
  // debug: true,
  key: (req) => {
    return req.url;
  },
  invalidate: async (config) => {
    if (config.clearCacheEntry) {
      await config.store.removeItem(config.uuid);
    }
  },
});

export const cachedHttp = axios.create({
  baseURL: CONFIG.API_URL,
  adapter: cache.adapter,
});

cachedHttp.interceptors.request.use(authRequest);
cachedHttp.interceptors.response.use(...authResponse);
